import { gql, useFragment } from "@apollo/client";

export default function Copyright({ entry }) {
  // Use Fragment
  const { complete, data } = useFragment({
    fragment: Copyright.fragments.entry,
    fragmentName: "CopyrightFragment",
    from: {
      __typename: entry.__typename,
      id: entry.id,
    },
  });
  if (!complete) {
    return;
  }

  // Variables
  const copyrightText = data.footerContent.copyright.copyrightLine;
  const copyrightLocation = data.footerContent.copyright.copyrightDatePosition;
  const currentDate = new Date().getFullYear();

  return(
    <div className="copyright">
      {copyrightLocation === 'front' && <span className="date">©{currentDate} </span>}
      {copyrightText}
      {copyrightLocation === 'back' && <span className="date"> ©{currentDate}</span>}
    </div>
  );
}

Copyright.fragments = {
  entry: gql`
    fragment CopyrightFragment on GeneralSettingsACF {
      id
      __typename
      footerContent {
        copyright {
          copyrightLine
          copyrightDatePosition
        }
      }
    }
  `
};